import { uniqueId } from 'lodash'
import React, { FC, useState } from 'react'
import ICON_LIST from '../../constants/taskIcon'
import Tips from '../common/Tips'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName, IconPrefix } from '@fortawesome/fontawesome-common-types'

interface Props {
  color: string
  icon: string
  changeCallback: (color: string) => void
  disabled?: boolean
}

const AddIconModule: FC<Props> = (props) => {
  const {
    color,
    icon,
    changeCallback,
    disabled,
  } = props

  const [isDisplay, setIsDisplay] = useState<boolean>(false)

  const open = () => {
    if (disabled) return
    setIsDisplay(true)
  }

  const close = () => {
    setIsDisplay(false)
  }

  const changeIcon = (selectIcon: string) => {
    changeCallback(selectIcon)
    setIsDisplay(false)
  }

  return (
    <>
      <div className="color_area">
        <button
          type="button"
          onClick={() => open()}
          style={{
            padding: "13px 13px 14px",
          }}
          disabled={disabled}
        >
          {
            icon.split(' ').length === 2 && (
              <FontAwesomeIcon
                icon={[icon.split(' ')[0] as IconPrefix, icon.split(' ')[1] as IconName]}
                style={{
                  color: color,
                  fontSize: "16px",
                }}
              />
            )
          }
          {ICON_LIST.find((v) => v.icon === icon)?.text || "アイコン"}
          <FontAwesomeIcon
            icon={['fas', 'angle-down']}
            style={{
              color: disabled ? "#999999" : "#666666",
              fontSize: "16px",
            }}
          />
        </button>
        <div className={`search_box ${isDisplay || 'none'}`}>
          <div
            style={{
              display: "flex",
              gap: "8px",
              width: "296px",
              flexWrap: "wrap",
            }}
          >
            {
              ICON_LIST.map((v) => (
                <div key={uniqueId()}>
                  <Tips
                    description={v.text}
                    className=""
                    icon={false}
                  >
                    <FontAwesomeIcon
                      icon={[v.icon.split(' ')[0] as IconPrefix, v.icon.split(' ')[1] as IconName]}
                      style={{
                        color: color,
                        fontSize: "20px",
                        width: "30px",
                        height: "30px",
                      }}
                      onClick={() => changeIcon(v.icon)}
                    />
                  </Tips>
                </div>
              ))
            }
          </div>
        </div>
      </div>
      <div className={`close_screen ${isDisplay || 'none'}`} role="presentation" onClick={() => close()} />
    </>
  )
}

AddIconModule.defaultProps = {
  disabled: false,
}

export default AddIconModule
